import { useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import Button from "@mui/material/Button";
import "assets/theme/admin_form.css";

const AddUserLeader = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    mobile: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.full_name.trim()) {
      newErrors.full_name = "पूर्ण नाव आवश्यक आहे (Full Name is required)";
    }
    if (!formData.email.trim()) {
      newErrors.email = "ईमेल पत्ता आवश्यक आहे (Email Address is required)";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "कृपया वैध ईमेल पत्ता टाका (Invalid email format)";
    }
    if (!formData.mobile.trim()) {
      newErrors.mobile = "मोबाईल नंबर आवश्यक आहे (Mobile Number is required)";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "मोबाईल क्रमांक १० अंकी असावा (Mobile must be 10 digits)";
    }
    if (!formData.password) {
      newErrors.password = "पासवर्ड आवश्यक आहे (Password is required)";
    } else if (formData.password.length < 6) {
      newErrors.password = "पासवर्ड किमान ६ अक्षरी असावा (Password must be at least 6 characters)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    try {
      await apiFetch("super_admin/add_user", {
        method: "POST",
        body: JSON.stringify({
          ...formData,
          role_id: 4, 
        }),
      });

      alert("User added successfully");
      navigate("/worker_list");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                👔 नवीन कार्यकर्ता जोडा (Add New Worker)
              </h4>
              <small className="text-white-50">
                Create a new worker under your ward
              </small>
            </div>
          </div>

          <Link to="/worker_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Worker List
          </Link>
        </div>

        {/* Card */}
        <div className="card shadow border-0" style={{ maxWidth: "750px" }}>
          <div className="card-body p-4">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row">
                {/* Full Name */}
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>
                    पूर्ण नाव / Full Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
                    name="full_name"
                    placeholder="पूर्ण नाव टाका / Enter full name"
                    value={formData.full_name}
                    onChange={handleChange}
                  />
                  {errors.full_name && (
                    <small className="text-danger d-block mt-1">{errors.full_name}</small>
                  )}
                </div>

                {/* Email */}
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>
                    ईमेल / Email Address <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    name="email"
                    placeholder="ईमेल टाका / Enter email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <small className="text-danger d-block mt-1">{errors.email}</small>
                  )}
                </div>

                {/* Mobile */}
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>
                    मोबाईल नंबर / Mobile Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
                    name="mobile"
                    placeholder="मोबाईल नंबर टाका / Enter mobile number"
                    value={formData.mobile}
                    onChange={handleChange}
                  />
                  {errors.mobile && (
                    <small className="text-danger d-block mt-1">{errors.mobile}</small>
                  )}
                </div>

                {/* Password */}
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>
                    पासवर्ड / Password <span className="text-danger">*</span>
                  </label>
                  <input
                    type="password"
                    className={`form-control ${errors.password ? "is-invalid" : ""}`}
                    name="password"
                    placeholder="पासवर्ड टाका / Enter password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  {errors.password && (
                    <small className="text-danger d-block mt-1">{errors.password}</small>
                  )}
                </div>
              </div>

              {/* Info Note */}
              <div className="alert alert-light border mt-2">
                <small className="text-muted">
                  हा वापरकर्ता आपोआप आपल्या प्रभागाशी जोडला जाईल. <br/>
                  This user will automatically be assigned to your ward.
                </small>
              </div>

              {/* Submit Button */}
              <div className="text-end mt-3">
                <button
                  type="submit"
                  className="btn px-4"
                  disabled={loading}
                  style={{
                    fontSize: "0.85rem",
                    background: "linear-gradient(45deg, #007bff, #00c6ff)",
                    color: "#fff",
                    borderRadius: "8px",
                  }}
                >
                  {loading
                    ? "संचयित करत आहे... / Saving..."
                    : "कार्यकर्ता जोडा / Add Worker"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddUserLeader;
